import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import MobileUpdateSaveContent from 'component/mobileUpdate/MobileUpdateSaveContent'
import MobileUpdateRemoveContent from 'component/mobileUpdate/MobileUpdateRemoveContent'
import MobileUpdateUpdateContent from 'component/mobileUpdate/MobileUpdateUpdateContent'

const SAVE = 'MOBILE_UPDATE_SAVE'
const REMOVE = 'MOBILE_UPDATE_REMOVE'
const UPDATE = 'MOBILE_UPDATE_UPDATE'

class MobileUpdateModal extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    modalType: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
    values: PropTypes.object,
    openEditModal: PropTypes.func,
    initialValues: PropTypes.object,
    user: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.state = {
      size: 'xs',
    }

    this.renderContent = this.renderContent.bind(this)
  }

  renderContent(props) {
    const newProps = {
      ...props,
    }

    switch (props.modalType) {
      case SAVE:
        return <MobileUpdateSaveContent {...newProps} />

      case REMOVE:
        return <MobileUpdateRemoveContent {...newProps} />

      case UPDATE:
        return <MobileUpdateUpdateContent {...newProps} />

      default:
        return <Fragment />
    }
  }

  render() {
    const { size } = this.state

    return (
      <Modal closeModal={this.props.closeModal} size={size}>
        {this.renderContent(this.props)}
      </Modal>
    )
  }
}

export default MobileUpdateModal
